import * as React from "react";
import {createRoot} from "react-dom/client";
import NewsletterRegistrationPage from "./NewsletterRegistrationPage";

export class NewsletterRegistrationPagePortal {
  public static run(element: HTMLElement): void {
    const root = createRoot(element);
    root.render(
      <React.Suspense
        fallback={
          <div>
            <div className="swiper-lazy-preloader">{/* Empty */}</div>
          </div>
        }
      >
        <NewsletterRegistrationPage />
      </React.Suspense>,
    );
  }
}

export default NewsletterRegistrationPagePortal;
